import { apiRequest } from '../../../api/client';
import type {
  InvitationResponseDto,
  MembershipResponseDto,
  RoleId,
  UserListResponseDto,
} from '../types/user';

export function listUsers(customerId: string): Promise<UserListResponseDto> {
  return apiRequest<UserListResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users`);
}

export function inviteUser(customerId: string, input: { email: string; roleId: RoleId; facilityIds: string[] }): Promise<InvitationResponseDto> {
  return apiRequest<InvitationResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users/invitations`, {
    method: 'POST',
    body: JSON.stringify({ email: input.email, role_ids: [input.roleId], facility_ids: input.facilityIds }),
  });
}

export function assignRoles(customerId: string, membershipId: string, roleIds: RoleId[]): Promise<MembershipResponseDto> {
  return apiRequest<MembershipResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users/${encodeURIComponent(membershipId)}/roles`, {
    method: 'PUT',
    body: JSON.stringify({ role_ids: roleIds }),
  });
}

export function resendInvitation(customerId: string, membershipId: string): Promise<InvitationResponseDto> {
  return apiRequest<InvitationResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users/${encodeURIComponent(membershipId)}/resend-invitation`, {
    method: 'POST', body: JSON.stringify({}),
  });
}

export function suspendUser(customerId: string, membershipId: string): Promise<MembershipResponseDto> {
  return apiRequest<MembershipResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users/${encodeURIComponent(membershipId)}/suspend`, {
    method: 'POST', body: JSON.stringify({}),
  });
}

export function reactivateUser(customerId: string, membershipId: string): Promise<MembershipResponseDto> {
  return apiRequest<MembershipResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users/${encodeURIComponent(membershipId)}/reactivate`, {
    method: 'POST', body: JSON.stringify({}),
  });
}

export function removeUser(customerId: string, membershipId: string): Promise<MembershipResponseDto> {
  return apiRequest<MembershipResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/users/${encodeURIComponent(membershipId)}`, {
    method: 'DELETE',
  });
}
